import React from 'react';

import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import HeaderHero from '../Components/HeaderHero';
import CompanyInfo from '../Components/CompanyInfo';
import CardProduct from '../Components/CardProduct';

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
  },

  cardGrid: {
    paddingTop: theme.spacing(9),
    paddingBottom: theme.spacing(9),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  cardContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
}));

const mainFeaturedPost = {
  title: 'S&P Glasphalt GV',
  description:
    'лучшая геосетка на Российском рынке Наша компания является эксклюзивным дистрибьютором завода производителя геосетки S&P Polska c 2008 года',
  imgText: 'main image description',
};

const Home = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <CssBaseline />
      <main>
        {/* Hero unit */}
        <div className={classes.heroContent}>
          <HeaderHero post={mainFeaturedPost} />
          <CompanyInfo />
        </div>
        <Container className={classes.cardGrid} maxWidth="md">
          {/* End hero unit */}
          <Grid className={classes.cardContainer} container>
            <CardProduct />
          </Grid>
        </Container>
      </main>
    </React.Fragment>
  );
};

export default Home;
